import 'sanitize.css'
import 'sanitize.css/typography.css'
import 'sanitize.css/forms.css'
const wrapPage = require('@raysync/common/config/wrap-page')
const { installJsonCacheBuster } = require('@raysync/common/config/json-cache-buster')
const { getCookie, setCookie } = require('@raysync/common/utils/cookie')

export const wrapPageElement = wrapPage

export const onClientEntry = () => {
  installJsonCacheBuster()
  const hasReferrerValue = getCookie('hasReferrerValue')
  if (!hasReferrerValue || Date.now() > +hasReferrerValue + 24 * 60 * 60 * 1000) {
    let referrer = window.document.referrer
    if (referrer) {
      referrer = referrer + window.location.search.slice(referrer.indexOf('&') > 0 ? 1 : 0)
    } else {
      referrer = window.location.href
    }
    setCookie('referrer', referrer, 3)
    setCookie('hasReferrerValue', Date.now(), 1)
  }
}
